var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinjob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m21.185 11.324-9.9 9.9M8.553 7.517h6.896M6.364 2A4.364 4.364 0 0 0 2 6.364v11.272A4.364 4.364 0 0 0 6.364 22h3.09A2.545 2.545 0 0 0 12 19.454v-3.818A3.636 3.636 0 0 1 15.636 12h3.819A2.545 2.545 0 0 0 22 9.455V6.364A4.364 4.364 0 0 0 17.636 2H6.364Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinjob);
export default __webpack_public_path__ + "static/media/pinjob.7ef4dcf25ea46db54e41296ba79c9d75.svg";
export { ForwardRef as ReactComponent };